import apiClient from "../../services/apiClient";

// 학생의 지필과제 목록 가져오기
export async function fetchStudentPaperAssignmentsAPI(studentId) {
  const response = await apiClient.get(
    `/api/v1/paper-assignment/student-assignments/?student_id=${studentId}`
  );
  return response.data;
}

// 학생 과제 제출
export async function submitStudentSolutionAPI(studentId, formData) {
  // FormData에 student_id 추가
  formData.append('student_id', studentId);
  
  const response = await apiClient.post("/api/v1/paper-assignment/submit-solution/", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
  return response.data;
}

// 첨삭 파일 다운로드 (S3 presigned URL 방식 사용 예정)
export async function downloadFeedbackFileAPI(studentId, s3Key) {
  const response = await apiClient.get(
    `/api/v1/paper-assignment/download/${encodeURIComponent(s3Key)}/?student_id=${studentId}`
  );
  return response.data;
}

// 원본 과제 파일 다운로드 (학생용)
export async function downloadOriginalAssignmentAPI(studentId, s3Key) {
  const response = await apiClient.get(
    `/api/v1/paper-assignment/download/${encodeURIComponent(s3Key)}/?student_id=${studentId}`
  );
  return response.data;
}

// 내 제출물 다운로드 (학생용)
export async function downloadMySubmissionAPI(studentId, s3Key) {
  const response = await apiClient.get(
    `/api/v1/paper-assignment/download/${encodeURIComponent(s3Key)}/?student_id=${studentId}`
  );
  return response.data;
}